import { render } from "./modalComponent.vue?vue&type=template&id=9d163722"
import script from "./modalComponent.vue?vue&type=script&lang=js"
export * from "./modalComponent.vue?vue&type=script&lang=js"

import "./modalComponent.vue?vue&type=style&index=0&id=9d163722&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__